import { useMemo } from 'react'
import { Stack, type StackProps } from '@mui/material'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'
import {
  getIconBoxDimensions,
  type GetIconBoxDimensionsParams,
} from './helpers/getIconBoxDimensions/getIconBoxDimensions'

export interface IconBoxProps extends Pick<StackProps, 'color' | 'sx'>, GetIconBoxDimensionsParams {
  children: React.ReactNode | ((dimensions: ReturnType<typeof getIconBoxDimensions>) => React.ReactNode)
}

export const IconBox: React.FC<IconBoxProps> = ({ children, sx, size, fullSize, ...props }) => {
  const dimensions = useMemo(() => getIconBoxDimensions({ size, fullSize }), [size, fullSize])

  return (
    <Stack
      sx={mergeSx(
        {
          flexShrink: 0,
          width: dimensions.size,
          height: dimensions.size,
          borderRadius: '50%',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => theme.tokens.ThemeColorCommonOnSurfaceContainer,
          '& svg': {
            fontSize: dimensions.fontSize,
          },
        },
        sx,
      )}
      {...props}
    >
      {typeof children === 'function' ? children(dimensions) : children}
    </Stack>
  )
}
